import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error-case-manager'
import { validatePhone } from '../../helpers/common';



const FacilityInformation = ({ work_order, onWorkOrderChange, onWorkOrderCreated, is_loading = true }) => {
    const navigate = useNavigate();
    const [facility, setFacility] = useState({
        facility_id: "",
        facility_name: "",
        facility_attn: "",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        facility_zip: "",
        facility_phone: "",
        facility_fax: "",
        facility_fee: "",
        facility_time_zone: "",
        blank_authorization: null
    });
    const [facilityAdd, setFacilityAdd] = useState({
        facility_id: "",
        facility_name: "",
        facility_attn: "",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        facility_zip: "",
        facility_phone: "",
        facility_fax: "",
        facility_fee: "",
        facility_time_zone: "",
        blank_authorization: null
    });
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);


    const [facilitySearch, setFacilitySearch] = useState({
        facility_name: "",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        client_zip: "",
    });
    const [editMode, setEditMode] = useState(false);
    const [addMode, setAddMode] = useState(false);



    useEffect(() => {
        if (work_order?.facility_id > 0) {
            getFacility(work_order?.facility_id);
        }

    }, [work_order?.facility_id]);



    const getFacility = async (facility_id) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-facility-by-id/" + facility_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacility(response?.data?.facility);
                setEditMode(false);
                setAddMode(false);

            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const addFacilityToWorkOrder = async (facility) => {

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-facility-to-work-order",
            {
                work_order_id: work_order?.work_order_id, facility_id: facility.facility_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setFacility(response?.data?.facility);
                    onWorkOrderChange({ facility_id: response?.data?.facility.facility_id });
                    setEditMode(false);
                    setAddMode(false);


                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });




    }


    const saveFacility = async (e) => {

        setIsBtn(true);
        
        const { facility_name, facility_address, facility_city, facility_state, facility_zip, facility_phone, facility_fax } = facilityAdd;

        if (!facility_name || !facility_address || !facility_city || !facility_state || !facility_zip
            || !validatePhone(facility_phone) || !validatePhone(facility_fax)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_name: facilityAdd.facility_name,
                facility_attn: facilityAdd.facility_attn,
                facility_address: facilityAdd.facility_address,
                facility_city: facilityAdd.facility_city,
                facility_state: facilityAdd.facility_state,
                facility_zip: facilityAdd.facility_zip,
                facility_phone: facilityAdd.facility_phone,
                facility_fax: facilityAdd.facility_fax,
                facility_fee: facilityAdd.facility_attn,
                facility_time_zone: facilityAdd.facility_time_zone,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    facility_info.facility_id = response?.data?.facility_id;
                    setFacility(facility_info);
                    addFacilityToWorkOrder(facility_info);

                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

                }
                setIsBtn(false)
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)


            });

        }
    }


    const updateFacility = async (e) => {

        setIsBtn(true);

        const { facility_name, facility_address, facility_city, facility_state, facility_zip, facility_phone, facility_fax } = facility;
        if (!facility_name || !facility_address || !facility_city || !facility_state || !facility_zip
            || !validatePhone(facility_phone) || !validatePhone(facility_fax)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_id: facility.facility_id,
                facility_name: facility.facility_name,
                facility_attn: facility.facility_attn,
                facility_address: facility.facility_address,
                facility_city: facility.facility_city,
                facility_state: facility.facility_state,
                facility_zip: facility.facility_zip,
                facility_phone: facility.facility_phone,
                facility_fax: facility.facility_fax,
                facility_time_zone: facility.facility_time_zone,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/update-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setFacility(facility_info);
                    setEditMode(false)

                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }


    const resetFacilityAdd = () => {

        setFacilityAdd({
            facility_id: "",
            facility_name: "",
            facility_attn: "",
            facility_address: "",
            facility_city: "",
            facility_state: "",
            facility_zip: "",
            facility_fee: "",
            facility_phone: "",
            facility_fax: "",
            facility_time_zone: "",
        });

    }

    return (
        <>
            <div className="card card-form  h-100 " >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0" >
                        <div className="col-md-5 col-sm-12 py-2 ps-3">  <h6 className=" fw-bold text-dark mt-2">FACILITY INFORMATION

                        </h6></div>

                        {work_order?.status < 1 &&

                            <div className="col-md-7 col-sm-12 text-md-end -2 my-2">


                                {addMode ?
                                    <>
                                        <button onClick={() => saveFacility()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                        <button onClick={() => { setAddMode(false); resetFacilityAdd(); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>

                                    </>
                                    :
                                    <>
                                        {editMode ?
                                            <>
                                                <button onClick={() => updateFacility()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 mt-1" type="button">CANCEL UPDATE</button>
                                            </>

                                            :
                                            <>
                                                <button onClick={() => { resetFacilityAdd(); setAddMode(true) }} className="btn btn-sm  btn-success me-1 mt-1" type="button">NEW</button>
                                                {(work_order?.facility_id > 0) &&
                                                    <>
                                                        <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-danger me-1 mt-1" type="button">EDIT</button>
                                                        {/*  <button onClick={() => toggleFacilityMask()} className="btn btn-sm btn-info mx-1" type="button">{facilityMask ? "Un-mask" : "Mask"} </button>  */}
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }







                            </div>
                        }
                    </div>




                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :
                        <>
                            {(work_order?.facility_id > 0 || addMode) ?

                                <form id="frm_facility" >

                                    <div className="row " >

                                        <div className="col-xl-12 col-lg-12" >
                                            <div className="" >
                                                {(addMode) ?

                                                    <>
                                                        <div className="row px-3 py-2 gx-2 ">

                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_name" >Facility*</label>

                                                                <input name="facility_name" className="form-control" type="text"
                                                                    value={facilityAdd.facility_name}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_name: e.target.value })
                                                                    }

                                                                />
                                                                {inputError && !facilityAdd.facility_name &&
                                                                    <span className="text-danger">Enter valid name</span>
                                                                }




                                                            </div>
                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_attn">ATTN</label>

                                                                <input name="facility_attn" className="form-control"
                                                                    value={facilityAdd.facility_attn}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_attn: e.target.value })
                                                                    }

                                                                />


                                                            </div>



                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_time_zone">Time Zone</label>

                                                                <select name="facility_time_zone" className=" form-select"
                                                                    value={facilityAdd.facility_time_zone}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_time_zone: e.target.value })
                                                                    }
                                                                >
                                                                    <option value="" selected={(!facilityAdd.facility_time_zone || facilityAdd.facility_time_zone == "") ? "selected" : ""} ></option>
                                                                    <option value="OUS" selected={(facilityAdd.facility_time_zone == "OUS") ? "selected" : ""} >OUS - Outside The United States</option>
                                                                    <option value="EST" selected={(facilityAdd.facility_time_zone == "EST") ? "selected" : ""}>EST: Eastern Standard Time</option>
                                                                    <option value="CST" selected={(facilityAdd.facility_time_zone == "CST") ? "selected" : ""}>CST: Central Standard Time</option>
                                                                    <option value="MST" selected={(facilityAdd.facility_time_zone == "MST") ? "selected" : ""}>MST - Mountain Standard Time</option>
                                                                    <option value="PST" selected={(facilityAdd.facility_time_zone == "PST") ? "selected" : ""}>PST - Pacific Standard Time</option>
                                                                    <option value="AST" selected={(facilityAdd.facility_time_zone == "AST") ? "selected" : ""}>AST- Alaska Standard Time</option>
                                                                    <option value="HST" selected={(facilityAdd.facility_time_zone == "HST") ? "selected" : ""}>HST - Hawaii Standard Time</option>
                                                                </select>


                                                            </div>




                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_address">ADDRESS*</label>
                                                                <input name="facility_address" id="facility_address" type="text" className="form-control"
                                                                    value={facilityAdd.facility_address}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_address: e.target.value })
                                                                    }

                                                                />
                                                                {inputError && !facilityAdd.facility_address &&
                                                                    <span className="text-danger">Enter address</span>
                                                                }



                                                            </div>


                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_city">CITY*</label>

                                                                <input name="facility_city" id="facility_city" type="text" className="form-control"
                                                                    value={facilityAdd.facility_city}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_city: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !facilityAdd.facility_city &&
                                                                    <span className="text-danger">Enter city</span>
                                                                }


                                                            </div>


                                                            <div className="col-3 my-2">
                                                                <div className="row gx-2" >
                                                                    <div className="col-5">

                                                                        <label htmlFor="facility_state">STATE*</label>

                                                                        <input name="facility_state" id="facility_state" type="text"
                                                                            className="form-control"
                                                                            value={facilityAdd.facility_state} onChange={(e) =>
                                                                                setFacilityAdd({ ...facilityAdd, facility_state: e.target.value })
                                                                            }
                                                                        />

                                                                        {inputError && !facilityAdd.facility_state &&
                                                                            <span className="text-danger">Enter state</span>
                                                                        }



                                                                    </div>
                                                                    <div className="col-7">
                                                                        <label htmlFor="facility_zip">ZIP*</label>

                                                                        <input name="facility_zip" id="facility_zip" type="text"
                                                                            className="form-control"
                                                                            value={facilityAdd.facility_zip} onChange={(e) =>
                                                                                setFacilityAdd({ ...facilityAdd, facility_zip: e.target.value })
                                                                            }
                                                                        />

                                                                        {inputError && !facilityAdd.facility_zip &&
                                                                            <span className="text-danger">Enter zip</span>
                                                                        }


                                                                    </div>





                                                                </div>
                                                            </div>




                                                            <div className="col-6 my-2">


                                                                <label htmlFor="facility_phone" >TELEPHONE</label>

                                                                <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                                                    value={facilityAdd.facility_phone} onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_phone: e.target.value })
                                                                    }
                                                                />

                                                                {inputError && !validatePhone(facilityAdd.facility_phone) &&
                                                                    <span className="text-danger">Enter a valid phone</span>
                                                                }




                                                            </div>

                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_fax">FAX</label>

                                                                <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                                                    value={facilityAdd.facility_fax} onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_fax: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !validatePhone(facilityAdd.facility_fax) &&
                                                                    <span className="text-danger">Enter a valid fax</span>
                                                                }

                                                            </div>


                                                        </div>

                                                    </>
                                                    :

                                                    <>
                                                        {(editMode) ?

                                                            <>
                                                                <div className="row px-3 py-2 gx-2 ">

                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_name" >Facility*</label>

                                                                        <input name="facility_name" className="form-control"
                                                                            value={facility.facility_name}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_name: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !facility.facility_name &&
                                                                            <span className="text-danger">Enter valid name</span>
                                                                        }




                                                                    </div>
                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_attn">ATTN</label>

                                                                        <input name="facility_attn" className="form-control"
                                                                            value={facility.facility_attn}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_attn: e.target.value })
                                                                            }

                                                                        />


                                                                    </div>




                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_address">ADDRESS*</label>
                                                                        <input name="facility_address" id="facility_address" type="text" className="form-control"
                                                                            value={facility.facility_address}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_address: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !facility.facility_address &&
                                                                            <span className="text-danger">Enter address</span>
                                                                        }



                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_city">CITY*</label>

                                                                        <input name="facility_city" id="facility_city" type="text" className="form-control"
                                                                            value={facility.facility_city}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_city: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !facility.facility_city &&
                                                                            <span className="text-danger">Enter city</span>
                                                                        }


                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <div className="row gx-2" >
                                                                            <div className="col-5">

                                                                                <label htmlFor="facility_state">STATE*</label>

                                                                                <input name="facility_state" id="facility_state" type="text"
                                                                                    className="form-control"
                                                                                    value={facility.facility_state} onChange={(e) =>
                                                                                        setFacility({ ...facility, facility_state: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !facility.facility_state &&
                                                                                    <span className="text-danger">Enter state</span>
                                                                                }



                                                                            </div>
                                                                            <div className="col-7">
                                                                                <label htmlFor="facility_zip">ZIP*</label>

                                                                                <input name="facility_zip" id="facility_zip" type="text"
                                                                                    className="form-control"
                                                                                    value={facility.facility_zip} onChange={(e) =>
                                                                                        setFacility({ ...facility, facility_zip: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !facility.facility_zip &&
                                                                                    <span className="text-danger">Enter zip</span>
                                                                                }


                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                    <div className="col-6 my-2">


                                                                        <label htmlFor="facility_phone" >TELEPHONE</label>

                                                                        <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                                                            value={facility.facility_phone} onChange={(e) =>
                                                                                setFacility({ ...facility, facility_phone: e.target.value })
                                                                            }
                                                                        />


                                                                        {inputError && !validatePhone(facility.facility_phone) &&
                                                                            <span className="text-danger">Enter a valid phone</span>
                                                                        }



                                                                    </div>

                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_fax">FAX</label>

                                                                        <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                                                            value={facility.facility_fax} onChange={(e) =>
                                                                                setFacility({ ...facility, facility_fax: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !validatePhone(facility.facility_fax) &&
                                                                            <span className="text-danger">Enter a valid fax</span>
                                                                        }
                                                                    </div>



                                                                </div>

                                                            </>
                                                            :

                                                            <>




                                                                <div className="row px-3 py-2 gx-2 ">

                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_name" >Facility</label><br />

                                                                        <label className="field-info">{facility.facility_name}</label>


                                                                    </div>
                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_attn">ATTN</label><br />

                                                                        <label className="field-info">{facility.facility_attn}</label>


                                                                    </div>
                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_time_zone">TIME ZONE</label><br />

                                                                        <label className="field-info">{facility.facility_time_zone}</label>


                                                                    </div>





                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_address">ADDRESS</label><br />
                                                                        <label className="field-info">{facility.facility_address}</label>


                                                                    </div>
                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_city">CITY</label><br />

                                                                        <label className="field-info">{facility.facility_city}</label>



                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <div className="row" >
                                                                            <div className="col-5">

                                                                                <label htmlFor="facility_state">STATE</label><br />

                                                                                <label className="field-info">{facility.facility_state}</label>


                                                                            </div>
                                                                            <div className="col-7">
                                                                                <label htmlFor="facility_zip">ZIP</label><br />

                                                                                <label className="field-info">{facility.facility_zip}</label>


                                                                            </div>
                                                                        </div>
                                                                    </div>




                                                              
                                                                    <div className="col-6 my-2">

                                                                        <label htmlFor="facility_phone" >TELEPHONE</label><br/>

                                                                        <label className="field-info">{facility.facility_phone ? facility.facility_phone : ""}</label>


                                                                    </div>

                                                                
                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_fax">FAX</label><br/>

                                                                        <label className="field-info">{facility.facility_fax ? facility.facility_fax : ""}</label>

                                                                    </div>



                                                                </div>






                                                            </>
                                                        }

                                                    </>

                                                }



                                                <div className="row pb-3 px-3 gx-5">


                                                    <div className="col-xl-12 col-lg-12 col-sm-12 my-2 ">


                                                        {(work_order && work_order?.facility_id > 0) &&

                                                            <>
                                                                <hr />
                                                                <label htmlFor="blank_authorization" className="mt-2" >Special Authorization: </label>
                                                                {work_order.blank_authorization ?
                                                                    <>
                                                                        <label className="field-info mt-2"> YES<br /></label>
                                                                        <div className="mt-1">
                                                                            <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/download-blank-authorization/" + work_order.work_order_id} target="_blank" >Download</a>

                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <label className="field-info mt-2"></label>
                                                                }
                                                            </>
                                                        }
                                                    </div>


                                                </div>





                                            </div>
                                        </div>






                                    </div>

                                </form>

                                :
                                <div className="row " >

                                    <div className="col-xl-12 col-lg-12 p-5" >

                                        <h5>In order to proceed with this case, please add a new or an existing facility.</h5>

                                    </div>

                                </div>
                            }
                        </>
                    }
                </div>



            </div>






        </>

    );
};

export default FacilityInformation;